import React from 'react';
import { Box, Container, Typography, Link as MuiLink } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import logoComite44 from '../../Images/logo-comite-44_transparent.png';
import logoFFRXIII from '../../Images/logo-FFRXIII.png';

const Footer: React.FC = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();
  const creationYear = 2024;

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: theme.palette.primary.main,
        borderTop: `3px solid ${theme.palette.secondary.main}`,
        py: 2,
        mt: 6,
        boxShadow: `0 -4px 12px rgba(0, 0, 0, 0.3)`,
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'nowrap',
            gap: { xs: 1, sm: 2 },
          }}
        >
          {/* Logo Comité */}
          <MuiLink
            href="https://www.facebook.com/p/Comite-Loire-Atlantique-rugby-%C3%A0-XIII-100070366539852/"
            rel="noopener noreferrer"
            target="_blank"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'scale(1.15) translateY(-2px)',
              },
            }}
          >
            <Box
              component="img"
              src={logoComite44}
              alt="logo Comité 44"
              loading="lazy"
              sx={{
                height: { xs: '2.25rem', sm: '2.75rem' },
                width: 'auto',
              }}
            />
          </MuiLink>

          {/* Copyright */}
          <Typography
            variant="body2"
            sx={{
              fontSize: { xs: '0.75rem', sm: '0.875rem' },
              color: theme.palette.secondary.main,
              fontWeight: 500,
              textAlign: 'center',
              flex: '0 1 auto',
              whiteSpace: 'nowrap',
            }}
          >
            ©{' '}
            {creationYear === currentYear
              ? currentYear
              : `${creationYear} - ${currentYear}`}{' '}
            Rezé XIII
          </Typography>

          {/* Logo FFR XIII */}
          <MuiLink
            href="https://www.ffr13.fr/"
            rel="noopener noreferrer"
            target="_blank"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'scale(1.15) translateY(-2px)',
              },
            }}
          >
            <Box
              component="img"
              src={logoFFRXIII}
              alt="logo FFRXIII"
              loading="lazy"
              sx={{
                height: { xs: '2.25rem', sm: '2.75rem' },
                width: 'auto',
              }}
            />
          </MuiLink>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
